// extracted by mini-css-extract-plugin
var _1 = "g_zET";
export { _1 as "absolutePosition" }
